import { combineReducers } from 'redux';
import { Client } from 'store/Client/Client.types';
import { errorReducerCreator, loadingReducerCreator } from 'store/utils';
import { createReducer } from 'typesafe-actions';
import { asyncActions, getReachableClientsAsync } from './ReachableClient.actions';

const items = createReducer<Client.ReachableClient[]>([]).handleAction(
  getReachableClientsAsync.success,
  (_state, { payload }) => payload.items,
);

/**
 * Loading reducer ↓
 */
export const loading = loadingReducerCreator(asyncActions);

/**
 * Error reducer ↓
 */
export const error = errorReducerCreator(asyncActions);

export const reachableClientReducer = combineReducers({
  items,
  loading,
  error,
});
